module.exports = __webpack_public_path__ + "img/meiwa_logo.08f3ed94.png";